import { Component, type ReactNode } from "react";

interface State {
  error: unknown;
}

/** ErrorBoundary keeps a render crash from becoming a blank black page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  componentDidCatch(error: unknown) {
    console.error("render crash:", error);
  }

  render() {
    if (this.state.error != null) {
      return (
        <div className="flex min-h-full flex-col items-center justify-center gap-3 p-8 text-center">
          <p className="text-sm font-medium text-ink">Something went wrong.</p>
          <p className="max-w-sm text-sm text-muted">
            The error has been logged to the browser console. Reloading usually helps.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-md border border-line px-3 py-1.5 text-sm text-ink hover:bg-elevated"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
